function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './chart.component.scss';
import template from './chart.html';
import { ChartFactory } from "./chart.factory";

export var ChartComponent = {
  template: template,
  styles: styles,
  bindings: {
    type: '@',
    data: '<' },

  controller: /*#__PURE__*/function () {ChartComponentController.$inject = ["$element", "$timeout", "Chartist"];
    function ChartComponentController($element, $timeout, Chartist) {
      "ngInject";_classCallCheck(this, ChartComponentController);
      this.$element = $element;
      this.$timeout = $timeout;
      this.Chartist = Chartist;

      this.ready = false;
      this.type = '';
      this.chartInstance = null;
    }_createClass(ChartComponentController, [{ key: "$onInit", value: function $onInit()

      {
        this.$chartContainer = this.$element.find('[chart-container]');
      } }, { key: "$postLink", value: function $postLink()

      {var _this = this;
        this.ready = true;
        this.$timeout(function () {
          _this.updateChart();
        });
      } }, { key: "$onChanges", value: function $onChanges(_ref)

      {var data = _ref.data,type = _ref.type;
        if (data) {
          this.data = angular.copy(data.currentValue);
        }
        if (data || type) {
          this.updateChart();
        }
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        this.destroyChart();
      } }, { key: "destroyChart", value: function destroyChart()

      {
        if (this.chartInstance) {
          this.chartInstance.off();
          this.chartInstance.detach();
        }
      } }, { key: "updateChart", value: function updateChart()

      {
        if (!this.ready) return false;
        this.destroyChart();
        this.chartInstance = ChartFactory(this.type)(
        this.Chartist,
        this.$chartContainer[0],
        this.data);

      } }]);return ChartComponentController;}() };




if (module.hot) module.hot.accept('./chart.component.scss');